"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcAvatarStacker = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var util_1 = require("@aperza/util");
var AcAvatar_1 = require("./AcAvatar");
var AcAvatarStacker = function (_a) {
    // if (names?.length < 1 && imageUrls?.length < 1) return <></>;
    var _b, _c, _d, _e, _f;
    var _g = _a.names, names = _g === void 0 ? [] : _g, _h = _a.imageUrls, imageUrls = _h === void 0 ? [] : _h, _j = _a.inChargeStatuses, inChargeStatuses = _j === void 0 ? [] : _j, inChargeUsers = _a.inChargeUsers, currentUserId = _a.currentUserId, _k = _a.size, size = _k === void 0 ? 30 : _k, _l = _a.maxLength, maxLength = _l === void 0 ? 3 : _l, _m = _a.tooltipPlacement, tooltipPlacement = _m === void 0 ? 'top' : _m;
    var _names = names || ((_b = inChargeUsers === null || inChargeUsers === void 0 ? void 0 : inChargeUsers.map) === null || _b === void 0 ? void 0 : _b.call(inChargeUsers, function (user) { return user.inChargeUserName; }));
    var _imageUrls = imageUrls || ((_c = inChargeUsers === null || inChargeUsers === void 0 ? void 0 : inChargeUsers.map) === null || _c === void 0 ? void 0 : _c.call(inChargeUsers, function (user) { return user.inChargeUserPhoto; }));
    var _inChargeStatuses = inChargeStatuses ||
        ((_d = inChargeUsers === null || inChargeUsers === void 0 ? void 0 : inChargeUsers.map) === null || _d === void 0 ? void 0 : _d.call(inChargeUsers, function (user) {
            if (!user.inChargeUserId)
                return 'NONE';
            if (user.inChargeUserId === currentUserId)
                return 'MINE';
            return 'NOT_MINE';
        }));
    var _o = __read(react_1.useState("AcAvatarStacker-" + util_1.UUIDUtil.uuid()), 1), tooltipId = _o[0];
    var gap = 25;
    var length = Math.min(Math.max(names.length, imageUrls.length), maxLength);
    var containerWidth = (length - 1) * gap + size;
    var avatars = [];
    for (var i = length - 1; i >= 0; i--) {
        if ((_imageUrls === null || _imageUrls === void 0 ? void 0 : _imageUrls[i]) && ((_f = (_e = _imageUrls === null || _imageUrls === void 0 ? void 0 : _imageUrls[i]) === null || _e === void 0 ? void 0 : _e.trim()) === null || _f === void 0 ? void 0 : _f.length) > 0) {
            avatars.push(react_1.default.createElement("div", { key: "avatar-" + i, className: "position-absolute", style: { marginLeft: i * gap, top: 0, left: 0 } },
                react_1.default.createElement(AcAvatar_1.AcAvatar, { imageUrl: _imageUrls[i], size: size, inCharge: _inChargeStatuses[i] })));
        }
        else if (_names[i]) {
            avatars.push(react_1.default.createElement("div", { key: "avatar-" + i, className: "position-absolute", style: { marginLeft: i * gap, top: 0, left: 0 } },
                react_1.default.createElement(AcAvatar_1.AcAvatar, { name: _names[i], size: size, inCharge: _inChargeStatuses[i] })));
        }
    }
    var validAvatarCount = avatars.length;
    if (validAvatarCount === 0) {
        avatars.push(react_1.default.createElement("div", { key: "avatar-0", className: "position-absolute", style: { marginLeft: 0 * gap, top: 0, left: 0 } },
            react_1.default.createElement(AcAvatar_1.AcAvatar, { size: size, className: "incharge-none" })));
    }
    var content = (react_1.default.createElement("div", { className: "position-relative", style: { width: containerWidth, height: size } }, avatars));
    if (validAvatarCount === 0)
        return content;
    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: tooltipPlacement, trigger: ['hover', 'focus'], overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: { zIndex: 1101 }, className: "aperza-app", id: tooltipId }, names === null || names === void 0 ? void 0 : names.map(function (name, index) { return (react_1.default.createElement("div", { className: "text-truncate", key: "avatar-tooltip-" + index }, name)); })) }, content));
};
exports.AcAvatarStacker = AcAvatarStacker;
exports.AcAvatarStacker.displayName = 'AcAvatarStacker';
//# sourceMappingURL=AcAvatarStacker.js.map